import { useState } from 'react';

import { Playground } from '../../../components/playground/Playground';
import { Description } from '../../../components/Description';

import AnimationsSlideExample from './AnimationsSlideExample';
import AnimationsSlideExampleRaw from './AnimationsSlideExample?raw';
import AnimationsFadeExample from './AnimationsFadeExample';
import AnimationsFadeExampleRaw from './AnimationsFadeExample?raw';
import AnimationsScaleExample from './AnimationsScaleExample';
import AnimationsScaleExampleRaw from './AnimationsScaleExample?raw';
import AnimationsRotateExample from './AnimationsRotateExample';
import AnimationsRotateExampleRaw from './AnimationsRotateExample?raw';

const animationExamples = [
    { id: 'slide', label: 'slide' },
    { id: 'fade', label: 'fade' },
    { id: 'scale', label: 'scale' },
    { id: 'rotate', label: 'rotate' },
] as const;

const examples = {
    slide: {
        example: <AnimationsSlideExample />,
        codeReact: AnimationsSlideExampleRaw,
    },
    fade: {
        example: <AnimationsFadeExample />,
        codeReact: AnimationsFadeExampleRaw,
    },
    scale: {
        example: <AnimationsScaleExample />,
        codeReact: AnimationsScaleExampleRaw,
    },
    rotate: {
        example: <AnimationsRotateExample />,
        codeReact: AnimationsRotateExampleRaw,
    },
} as const;

export const Animations = () => {
    const [selectedExampleId, setSelectedExampleId] = useState<keyof typeof examples>('slide');

    const currentExample = examples[selectedExampleId];

    const handlePillKeyDown = (event: React.KeyboardEvent<HTMLDivElement>, exampleId: keyof typeof examples) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setSelectedExampleId(exampleId);
        }
    };

    return (
        <div>
            <Description headline='CSS Animations' anchor='css-animations' />
            <Playground
                example={
                    <div>
                        <ul className='nav nav-pills nav-pills-filled nav-justified margin-bottom-25'>
                            {animationExamples.map(({ id, label }) => (
                                <li key={id} className={selectedExampleId === id ? 'active' : ''}>
                                    <div
                                        role='button'
                                        tabIndex={0}
                                        onClick={() => setSelectedExampleId(id)}
                                        onKeyDown={event => handlePillKeyDown(event, id)}
                                        className='text-transform-capitalize'
                                    >
                                        {label}
                                    </div>
                                </li>
                            ))}
                        </ul>
                        <div className='margin-top-15'>{currentExample.example}</div>
                    </div>
                }
                codeReact={currentExample.codeReact}
                codeHtml=''
            />
        </div>
    );
};
